/**
 * Company information for invoices and legal documents
 * This information is public and appears on all invoices
 */
export const COMPANY_INFO = {
  name: 'Markku.fi Pientalohuolto Oy',
  businessId: '3246769-2', // Y-tunnus
  vatId: 'FI32467692', // ALV-tunnus
  addressLine1: 'Tekniikantie 14',
  addressLine2: '01250 Espoo',
  phone: '+358 50 5555 797',
  email: 'info@markku.fi',
  website: 'https://markku.fi',
  iban: 'FI4615443000259239',
  bankName: 'Nordea',
  bic: 'NDEAFIHH',
} as const

/**
 * Type-safe access to company information
 */
export type CompanyInfo = typeof COMPANY_INFO
